// extracted by mini-css-extract-plugin
export default {"button":"ResaleSubmitted_button__WT5dp","img":"ResaleSubmitted_img__9nmGk","container":"ResaleSubmitted_container__pR7DY","message":"ResaleSubmitted_message__dMrFE"};